import DigitalNatureWebComponent from "@digital-nature-ltd/web-component";
import template from "./templates/digital-nature-carousel-template.html?raw"

class DigitalNatureCarouselComponent extends DigitalNatureWebComponent
{
    controls = [];
    slides = null;

    constructor() {
        super({template: template});

        // initialise the links
        this.initialiseSlides(this.getElementsByTagName('digital-nature-carousel-slide'));

        this.addScrollHandler();
    }



    /** GETTERS **/
    getVisibleSlide()
    {
        for (let slide of this.slides) {
            if (this.isElementVisible(slide)) {
                return slide;
            }
        }
    }




    /** SETTERS **/
    setActiveSlideOnControls(activeSlideId) {
        // update all the controls
        this.controls.forEach((control) => this.updateActiveSlideOnControl(control, activeSlideId), activeSlideId);
    }



    /** UTILITIES **/
    /**
     * Initialises the slides within this carousel
     *
     * @param {Array} slides
     */
    initialiseSlides(slides)
    {
        this.slides = slides;
    }

    /**
     * Checks if a slide is visible within the carousel
     *
     * @param slide
     * @returns {boolean}
     */
    isElementVisible (slide) {
        const { left, right, width } = slide.getBoundingClientRect()
        const holderRect = this.getBoundingClientRect()

        return left <= holderRect.left
            ? holderRect.left - left <= width
            : right - holderRect.right <= width
    }

    /**
     * Adds a set of controls to the carousel
     *
     * @param controlEl
     */
    addControl(controlEl) {
        this.controls.push(controlEl);
    }

    /**
     * Updates the active slide on a control
     *
     * @param control
     * @param activeSlideId
     */
    updateActiveSlideOnControl(control, activeSlideId) {
        control.setActiveLink(activeSlideId);
    }





    /** EVENT HANDLERS **/
    /**
     * Adds a scroll handler to the carousel. Used to trigger control updates
     * when a new slide is visible.
     */
    addScrollHandler()
    {
        let carousel = this;

        // Timer, used to detect whether horizontal scrolling is over
        let timer = null;
        // Scrolling event start
        carousel.addEventListener('scroll', function () {
            clearTimeout(timer);
            // Renew timer
            timer = setTimeout(function () {
                // No scrolling event triggered. It is considered that
                // scrolling has stopped do what you want to do, such
                // as callback processing
                let visibleSlide = carousel.getVisibleSlide();
                carousel.setActiveSlideOnControls(`#${visibleSlide.id}`);

                // replace the # in the page url with the id of the visible slide
                window.history.replaceState({}, '', `#${visibleSlide.id}`);

            }, 100);
        });
    }
}

// add the custom element to the registry
customElements.define('digital-nature-carousel', DigitalNatureCarouselComponent);